import { atom } from 'recoil';

export const authState = atom({
  key: "auth",
  default: null
});

export const actionState = atom({
  key: "action",
  default: {
    open: false,
    name: 'note',
    message: 'Are you sure?'
  }
});

export const toastsState = atom({
  key: "toasts",
  default: []
});